/* NYLA Funnel theme */
(function () {
  'use strict';

  /* ---------------- Order form ---------------- */
  function initOrderForm(root) {
    var dataEl = root.querySelector('[data-order-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.querySelector('form[data-order-form]');
    if (!form) return;
    var status = form.querySelector('[data-form-status]');
    var totalEl = form.querySelector('[data-summary-total]');
    var submitBtn = form.querySelector('[data-submit]');

    function selectedScent() {
      var el = form.querySelector('input[name="scent"]:checked');
      return el ? el.value : null;
    }
    function selectedPackIndex() {
      var el = form.querySelector('input[name="pack"]:checked');
      return el ? Number(el.dataset.index) : 0;
    }
    function currentVariant() {
      var s = selectedScent();
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].value === s) return data.variants[i];
      }
      return null;
    }

    function render() {
      var v = currentVariant();
      var p = selectedPackIndex();
      form.querySelectorAll('[data-pack-price]').forEach(function (el) {
        var i = Number(el.dataset.packPrice);
        el.textContent = v && v.packs[i] ? v.packs[i].price : '—';
      });
      form.querySelectorAll('[data-pack-compare]').forEach(function (el) {
        var i = Number(el.dataset.packCompare);
        var show = v && v.packs[i] && v.packs[i].save_cents > 0;
        el.textContent = show ? v.packs[i].compare : '';
        el.hidden = !show;
      });
      var priceEl = form.querySelector('[data-summary-price]');
      if (priceEl) priceEl.textContent = v && v.packs[p] ? v.packs[p].price : '—';
      if (totalEl) totalEl.textContent = v && v.packs[p] ? v.packs[p].total : '—';
    }

    form.addEventListener('change', function () {
      if (status) status.textContent = '';
      render();
    });

    // Pick a scent from elsewhere on the page (hero spotlight)
    root.addEventListener('nyla:pick-scent', function (ev) {
      var wanted = (ev.detail || '').toString().trim().toLowerCase();
      var inputs = form.querySelectorAll('input[name="scent"]');
      for (var i = 0; i < inputs.length; i++) {
        var match = inputs[i].value.toLowerCase() === wanted ||
          (inputs[i].dataset.label || '').toLowerCase() === wanted;
        if (match && !inputs[i].disabled) { inputs[i].checked = true; break; }
      }
      render();
    });

    function setError(input, msg) {
      var err = form.querySelector('[data-error-for="' + input.name + '"]');
      if (msg) {
        input.setAttribute('aria-invalid', 'true');
        if (err) err.textContent = msg;
      } else {
        input.removeAttribute('aria-invalid');
        if (err) err.textContent = '';
      }
    }

    function validate() {
      var firstBad = null;
      var fields = form.querySelectorAll('[data-required]');
      fields.forEach(function (input) {
        var val = (input.value || '').trim();
        var msg = '';
        if (!val) msg = data.messages.required;
        else if (input.name === 'phone') {
          var digits = val.replace(/[\s\-.]/g, '').replace(/^(\+216|00216|216)/, '');
          if (!/^[2-9]\d{7}$/.test(digits)) msg = data.messages.phone;
        }
        setError(input, msg);
        if (msg && !firstBad) firstBad = input;
      });
      return firstBad;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (status) status.textContent = '';
      var v = currentVariant();
      if (!data.hasProduct) { if (status) status.textContent = data.messages.noProduct; return; }
      if (!v) { if (status) status.textContent = data.messages.pickScent; return; }
      if (!v.available) { if (status) status.textContent = data.messages.soldOut; return; }
      var bad = validate();
      if (bad) { bad.focus(); return; }

      var pack = data.packs[selectedPackIndex()];
      var qty = pack ? pack.receive : 1;
      var name = form.elements.name.value.trim();
      var parts = name.split(/\s+/);
      var first = parts.shift();
      var last = parts.join(' ') || first;
      var phone = form.elements.phone.value.trim();
      var gov = form.elements.governorate ? form.elements.governorate.value : '';
      var address = form.elements.address.value.trim();

      var q = [
        'checkout[shipping_address][first_name]=' + encodeURIComponent(first),
        'checkout[shipping_address][last_name]=' + encodeURIComponent(last),
        'checkout[shipping_address][address1]=' + encodeURIComponent(address),
        gov ? 'checkout[shipping_address][city]=' + encodeURIComponent(gov) : '',
        'checkout[shipping_address][country]=TN',
        'checkout[shipping_address][phone]=' + encodeURIComponent(phone),
        'attributes[phone]=' + encodeURIComponent(phone),
        'attributes[source]=' + encodeURIComponent(data.source || ''),
        'attributes[pack]=' + encodeURIComponent(pack ? pack.title : '')
      ];
      if (data.discountCode) q.push('discount=' + encodeURIComponent(data.discountCode));
      q = q.filter(Boolean);

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = data.messages.sending; }

      window.location.href = '/cart/' + v.id + ':' + qty + '?' + q.join('&');
    });

    render();
  }

  /* ---------------- Hero: pick scent + scroll ---------------- */
  function initScentLinks() {
    document.querySelectorAll('[data-pick-scent]').forEach(function (link) {
      link.addEventListener('click', function (ev) {
        var target = document.getElementById('order');
        if (!target) return;
        ev.preventDefault();
        target.dispatchEvent(new CustomEvent('nyla:pick-scent', { detail: link.dataset.pickScent }));
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        var first = target.querySelector('input[name="scent"]:checked');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
      });
    });
  }

  /* ---------------- Sticky CTA ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-cta]');
    var order = document.getElementById('order');
    if (!bar || !order || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-sticky');
    var link = bar.querySelector('a');
    var scrolled = false, orderVisible = false;
    function update() {
      var show = scrolled && !orderVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (link) link.tabIndex = show ? 0 : -1;
    }
    window.addEventListener('scroll', function () {
      var s = window.scrollY > 500;
      if (s !== scrolled) { scrolled = s; update(); }
    }, { passive: true });
    new IntersectionObserver(function (entries) {
      orderVisible = entries[0].isIntersecting; update();
    }, { threshold: 0.1 }).observe(order);
  }

  /* ---------------- Carousels ---------------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-carousel-track]');
      if (!track) return;
      var counter = c.querySelector('[data-carousel-counter]');
      if (counter) {
        var total = track.children.length;
        var tick = function () {
          var item = track.firstElementChild;
          var step = item ? item.getBoundingClientRect().width + 14 : 1;
          var i = Math.min(total, Math.round(Math.abs(track.scrollLeft) / step) + 1);
          counter.textContent = i + ' / ' + total;
        };
        track.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true });
      }
      c.querySelectorAll('[data-carousel-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = track.firstElementChild;
          var step = item ? item.getBoundingClientRect().width + 14 : 300;
          var dir = btn.dataset.carouselDir === 'next' ? 1 : -1;
          // RTL: moving forward scrolls toward negative scrollLeft
          var rtl = getComputedStyle(track).direction === 'rtl';
          track.scrollBy({ left: (rtl ? -dir : dir) * step, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gallery-main] img');
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
          if (main) {
            main.src = t.dataset.src;
            main.srcset = t.dataset.srcset || '';
            main.alt = t.dataset.alt || '';
          }
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-order-root]').forEach(initOrderForm);
    initScentLinks();
    initSticky();
    initCarousels();
    initGallery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init inside the theme editor when a section reloads
  document.addEventListener('shopify:section:load', function (ev) {
    ev.target.querySelectorAll('[data-order-root]').forEach(initOrderForm);
    initScentLinks(); initCarousels(); initGallery();
  });
})();

/* =========================================================
   EasySell: highlight the family pack offer (green frame + badge, no blinking)
   EasySell redraws its form, so we watch the page and re-apply.
   ========================================================= */
(function () {
  'use strict';
  var HOT_TEXT = 'عائل';           // matches "pack العائلة" / "عائلة" 
  var BADGE = '★ الأكثر طلبًا';

  function mark() {
    var offers = document.querySelectorAll('.es-qo-container');
    if (!offers.length) return;
    var hot = null;
    offers.forEach(function (o) {
      if (!hot && (o.textContent || '').indexOf(HOT_TEXT) !== -1) hot = o;
    });
    if (!hot) hot = offers[offers.length - 1];
    // remove the badge/frame from any other offer
    offers.forEach(function (o) {
      if (o === hot) return;
      o.classList.remove('nyla-hot');
      var old = o.querySelector('.nyla-hot__badge'); if (old) old.remove();
    });
    if (!hot.classList.contains('nyla-hot')) hot.classList.add('nyla-hot');
    // badge «الأكثر طلبًا» removed: clean up any old one
    var oldBadge = hot.querySelector('.nyla-hot__badge');
    if (oldBadge) oldBadge.remove();
  }

  function start() {
    mark();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(mark, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* =========================================================
   Offer countdown: days / hours / minutes / seconds, in Arabic
   Counts to the end date set in LP · Hero (Tunisia time, UTC+1).
   Accepts "2026-10-05 23:59" or just "2026-10-05" (= end of that day).
   Empty date = midnight today. Hidden once it reaches zero.
   ========================================================= */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dayWord(n) { return n === 2 ? 'يومين' : (n >= 3 && n <= 10 ? 'أيام' : 'يوم'); }

  function endOf(el) {
    var v = (el.getAttribute('data-countdown') || '').trim().replace('/', '-').replace('/', '-');
    var m = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (m) {
      var iso = m[1] + '-' + pad(+m[2]) + '-' + pad(+m[3]) + 'T' +
        (m[4] ? pad(+m[4]) + ':' + m[5] : '23:59') + ':00+01:00';
      var d = new Date(iso);
      if (!isNaN(d.getTime())) return d;
    }
    var e = new Date(); e.setHours(23, 59, 59, 999); return e;
  }

  function initTimer(el) {
    if (el._nylaTimer) clearInterval(el._nylaTimer);
    var end = endOf(el);
    var q = function (s) { return el.querySelector(s); };
    var dBox = q('[data-unit-d]'), d = q('[data-d]'), dl = q('[data-d-label]');
    var h = q('[data-h]'), mi = q('[data-m]'), s = q('[data-s]');
    function tick() {
      var left = Math.floor((end - new Date()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(el._nylaTimer); return; }
      el.hidden = false;
      var days = Math.floor(left / 86400);
      if (dBox) { dBox.hidden = days === 0; if (d) d.textContent = days; if (dl) dl.textContent = dayWord(days); }
      if (h) h.textContent = pad(Math.floor(left % 86400 / 3600));
      if (mi) mi.textContent = pad(Math.floor(left % 3600 / 60));
      if (s) s.textContent = pad(left % 60);
    }
    el._nylaTimer = setInterval(tick, 1000);
    tick();
  }

  function start(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(initTimer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
  else start();

  // Theme editor: restart the timer when the hero section is saved
  document.addEventListener('shopify:section:load', function (ev) { start(ev.target); });
})();

/* =========================================================
   Hero product carousel: swipe, arrows, thumbnails, counter
   ========================================================= */
(function () {
  'use strict';
  function initCar(car) {
    if (car._nylaCar) return;
    car._nylaCar = true;
    var track = car.querySelector('[data-hcar-track]');
    if (!track) return;
    var slides = track.children;
    var total = slides.length;
    var count = car.querySelector('[data-hcar-count]');
    var thumbs = car.querySelectorAll('[data-hcar-thumb]');
    var current = 0;

    function isRtl() { return getComputedStyle(track).direction === 'rtl'; }
    function index() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(total - 1, Math.round(Math.abs(track.scrollLeft) / w)));
    }
    function goTo(i) {
      i = (i + total) % total;                     // loop around
      track.scrollTo({ left: (isRtl() ? -1 : 1) * i * track.clientWidth });
    }
    function update() {
      var i = index();
      if (i === current && count && count.textContent.indexOf((i + 1) + ' /') === 0) return;
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + total;
      thumbs.forEach(function (t) {
        var on = Number(t.getAttribute('data-hcar-thumb')) === i;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf); raf = requestAnimationFrame(update);
    }, { passive: true });

    car.querySelectorAll('[data-hcar-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(index() + (btn.getAttribute('data-hcar-dir') === 'next' ? 1 : -1));
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-hcar-thumb'))); });
    });
    window.addEventListener('resize', function () { goTo(current); });
  }

  function start(root) { (root || document).querySelectorAll('[data-hcar]').forEach(initCar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
  else start();
  document.addEventListener('shopify:section:load', function (ev) { start(ev.target); });
})();

/* =========================================================
   Hero headline lines ("|" in the headline): shrink the font
   just enough so every line fits on one line
   ========================================================= */
(function () {
  'use strict';
  function fit(h) {
    h.style.fontSize = '';
    var lines = h.querySelectorAll('.h1-line');
    if (!lines.length) return;
    var avail = h.clientWidth;
    var widest = 0;
    lines.forEach(function (l) { widest = Math.max(widest, l.scrollWidth); });
    if (widest > avail && avail > 0) {
      var base = parseFloat(getComputedStyle(h).fontSize);
      h.style.fontSize = Math.max(16, Math.floor(base * avail / widest * 0.98)) + 'px';
    }
  }
  function all() { document.querySelectorAll('[data-fit-lines]').forEach(fit); }
  function start() {
    all();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 100); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', all);
})();